import { useQuery } from "@tanstack/react-query";
import { instance } from "@/apis";
import { normalizeKnowledgeContent } from "@/utils/knowledge-content";

export const useMessagesQuery = ({
  chatId,
  enabled = true,
}: {
  chatId: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ["messages", chatId],
    queryFn: async () => {
      // temp ID는 실제 API 호출하지 않고 빈 배열 반환
      if (chatId.startsWith("temp")) {
        return [];
      }
      return instance.get(`/api/df/user/chat/${chatId}`).then((res) => {
        const messages = res.data.data;
        return Array.isArray(messages) ? messages.map(normalizeKnowledgeContent) : messages;
      });
    },
    enabled: enabled && !!chatId && !chatId.startsWith("temp"), // chatId가 있고 enabled가 true일 때만 쿼리 실행
    staleTime: Infinity, // 캐시를 stale로 만들지 않음 (수동 업데이트만 사용)
    gcTime: Infinity, // 가비지 컬렉션하지 않음
    refetchOnMount: false, // 마운트 시 재fetch 방지 (캐시 사용)
    refetchOnWindowFocus: false, // 윈도우 포커스 시 재fetch 방지
    refetchOnReconnect: false, // 재연결 시 재fetch 방지
    notifyOnChangeProps: "all", // 모든 변경사항에 대해 리렌더링
  });
};
